module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-footer"
  }, [_c('a', {
    attrs: {
      "href": "tel:+4571992895"
    }
  }, [_c('div', {
    staticClass: "menuitem"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("\n            " + _vm._s(_vm.$t('layout.mobileFooter.phone')) + "\n        ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:hello@deveo.dk"
    }
  }, [_c('div', {
    staticClass: "menuitem"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("\n            " + _vm._s(_vm.$t('layout.mobileFooter.email')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menuitem",
    on: {
      "click": function($event) {
        _vm.$store.state.mobileMenu = !_vm.$store.state.mobileMenu
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("\n        " + _vm._s(_vm.$t('layout.mobileFooter.menu')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c3e1cd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layout/mobile-footer.vue
// module id = 316
// module chunks = 1